import "./VictoryModal.style.css";

import { GameAnswerState } from "../../../utils/states/GamePageStates/GameAnswerState";
import {
  getAttemptWordCase,
  getEmojiRows,
} from "../../../utils/functions/victoryModalHelpers";
import {
  Button,
  ButtonColor,
  ButtonSize,
} from "../../../components/base/Button/Button";
import { CSSTransition } from "react-transition-group";
import { useEffect, useRef, useState } from "react";

import { CrossIcon24 } from "../../../components/icons/CrossIcon24";
import { CopyIcon18 } from "../../../components/icons/CopyIcon18";
import { IconHeart24 } from "../../../components/icons/IconHeart/IconHeart24";

interface VictoryModalProps {
  gameId: string;
  objectName: string;
  gameName: string;
  gameAnswerStates: GameAnswerState[];
  handleCloseDialogue: () => void;
  handleAddToFavorites: () => void;
}

export const VictoryModal = ({
  gameId,
  objectName,
  gameName,
  gameAnswerStates,
  handleCloseDialogue,
  handleAddToFavorites,
}: VictoryModalProps) => {
  const ref = useRef<HTMLDivElement>(null);

  const [isVisible, setIsVisible] = useState<boolean>(false);
  useEffect(() => {
    setIsVisible(true);
  }, []);

  const attemptCount = gameAnswerStates.length;
  const attemptWord = getAttemptWordCase(attemptCount);

  const [clickedFavorite, setClickedFavorite] = useState<boolean>(false);

  const getEmojisMessage = () => {
    const emojiRows = getEmojiRows(gameAnswerStates);
    let emojisMessage = "";
    emojiRows.forEach((emojiRow, index) => {
      emojisMessage += emojiRow + (index < emojiRows.length - 1 ? "\n" : "");
    });

    return emojisMessage;
  };

  const getCopyableMessage = () => {
    const attemptsMessage = `У меня получилось пройти "${gameName}" в YOURDLE за ${attemptCount} ${attemptWord}!`;
    const gameLinkMessage = `Ссылка на игру: https://yourdle.fun/gallery/${gameId}`;
    const emojisMessage = getEmojisMessage();

    return `${attemptsMessage}\n\n${emojisMessage}\n\n${gameLinkMessage}`;
  };

  const handleClickCopyButton = () => {
    navigator.clipboard.writeText(getCopyableMessage());
  };

  const handleClickCloseButton = () => {
    setIsVisible(false);
    handleCloseDialogue();
  };

  const handleClickFavoriteButton = () => {
    setClickedFavorite(true);
    handleAddToFavorites();
  };

  const renderCopyableMessage = () => {
    const emojiRows = getEmojiRows(gameAnswerStates);

    return (
      <div className="victory__message">
        У меня получилось пройти "{gameName}" в YOURDLE за {attemptCount}{" "}
        {attemptWord}!
        <br />
        <br />
        {emojiRows.map((emojiRow) => (
          <span>
            {emojiRow}
            <br />
          </span>
        ))}
        <br />
        <div className="victory__message__link">
          Ссылка на игру:{" "}
          <span className="victory__message__link-text">
            https://yourdle.fun/gallery/{gameId}
          </span>
        </div>
        <Button
          className="victory__message__copy-button"
          color={ButtonColor.Empty}
          size={ButtonSize.Small}
          icon={<CopyIcon18 />}
          onClick={handleClickCopyButton}
        />
      </div>
    );
  };

  return (
    <CSSTransition
      in={isVisible}
      timeout={300}
      classNames={"victory_animated"}
      unmountOnExit
      nodeRef={ref}
    >
      <div className="victory" ref={ref}>
        <div className="victory__header">
          <span className="victory__header__title">Победа!</span>
          <span className="victory__header__text">
            Вы отгадали{" "}
            <span className="victory__header__text__object">{objectName}</span>{" "}
            за {attemptCount} {attemptWord}.
          </span>
        </div>
        <Button
          className="victory__close-button"
          color={ButtonColor.Empty}
          icon={<CrossIcon24 />}
          onClick={handleClickCloseButton}
        />
        {renderCopyableMessage()}
        <div className="victory__controls">
          <Button
            className="victory__favorite-button"
            disabled={clickedFavorite}
            color={ButtonColor.Border}
            icon={<IconHeart24 />}
            text={clickedFavorite ? "В избранном" : "В избранное"}
            onClick={handleClickFavoriteButton}
          />
        </div>
      </div>
    </CSSTransition>
  );
};
